



























































import ripple from "../../components/ripple.vue"
import tooltip from "../../components/tooltip.vue"
import gbutton from "../../components/button.vue"
import loadingBar from "../../components/loadingBar.vue"
import gTable, {Rows} from "../../components/table.vue"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { frontendClient } from "../../lib/client";
import { setInterval } from "timers";

@Component({
    components : {
        ripple,
        gbutton,
        loadingBar,
        gTable,
        tooltip,
    },
})
export default class Jobs extends Vue{
    perc:number = 0;
    incompleteJobs: Rows[] = [];
    completeJobs: Rows[] = [];

    completePage:number = 1;
    incompletePage:number = 1;
    
    incompleteLoad:number = 0;
    completeLoad:number = 0;

    jobsList: Rows[] = []

    getJobs(){
        this.getIncomplete();
        this.getComplete();
    }

    getIncomplete(){
        this.incompleteLoad = 20;
        // alert(this.incompletePage);
        frontendClient.postEx('jobs/list',{page:this.incompletePage,hasCompleted: false})
        .then((data) => {
            if(!data.jobs || data.jobs.length == 0){
                this.incompletePage = -1;
                return;
            }
            let divided = 80 / data.jobs.length;
            for(let i=0; i<data.jobs.length; i++){
                this.incompleteLoad += divided
                this.incompleteJobs.push(data.jobs[i]);
            }
            this.incompletePage++;
        })
        .catch((err) => {
            frontendClient.giveError(err);
        }).finally(() => {
            this.incompleteLoad = 100;
        })
    }
    getComplete(){
        this.completeLoad = 20;
        // alert(this.completePage);
        frontendClient.postEx('jobs/list',{page:this.completePage,hasCompleted: true})
        .then((data) => {
            if(!data.jobs || data.jobs.length == 0){
                this.completePage = -1;
                return;
            }
            let divided = 80 / data.jobs.length;
            for(let i=0; i<data.jobs.length; i++){
                this.completeLoad += divided;
                this.completeJobs.push(data.jobs[i]);
            }
            this.completePage++;
        })
        .catch((err) => {
            frontendClient.giveError(err);
        }).finally(() => {
            this.completeLoad = 100;
        })
    }


    mounted(){
       this.$emit('scope','jobs');

       this.getJobs()
    };
}
